import React from "react";
import { Col, Row } from "react-bootstrap";
import { NumericFormat } from "react-number-format";
import { Link } from "react-router-dom";
import { currency, thousandsdisplay } from "../../../Common/Credentials";
import CountUp from "react-countup";
import { Skeleton } from "@mui/material";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { ShoppingBag } from "lucide-react";

const PurchaseCards = ({ data, poloader, theme }) => {
  return (
    <Row>
      <Col sm={6} lg={3}>
        <Link to={{ pathname: "/purchaseorder" }} style={{ textDecoration: "none" }}>
          <div className="purchase-stat-card mb-3">
            <div className="stat-label">Total Purchase Amount</div>
            {poloader ? (
              <Skeleton variant="rounded" width={150} height={24} />
            ) : (
              <div className="stat-value">
                <span style={{ fontSize: "0.85rem", fontWeight: 600 }}>{currency}&nbsp;</span>
                <NumericFormat
                  displayType={"text"}
                  value={data.totalfyPOtransaction}
                  decimalScale={2}
                  fixedDecimalScale={true}
                  disabled={true}
                  thousandSeparator={true}
                  thousandsGroupStyle={thousandsdisplay}
                />
              </div>
            )}
            <div className="stat-icon-badge purple">
              <TrendingUpIcon fontSize="small" />
            </div>
          </div>
        </Link>
      </Col>
      <Col sm={6} lg={3}>
        <Link to={{ pathname: "/purchaseorder" }} style={{ textDecoration: "none" }}>
          <div className="purchase-stat-card mb-3">
            <div className="stat-label">Total Purchases</div>
            {poloader ? (
              <Skeleton variant="rounded" width={100} height={24} />
            ) : (
              <div className="stat-value">
                <CountUp
                  start={0}
                  end={data.totalpoinfyyear === undefined ? 0 : data.totalpoinfyyear}
                  duration={1.5}
                />
              </div>
            )}
            <div className="stat-icon-badge blue">
              <ShoppingBag fontSize="small" />
            </div>
          </div>
        </Link>
      </Col>
      <Col sm={6} lg={3}>
        <Link to={{ pathname: "/purchaseorder" }} style={{ textDecoration: "none" }}>
          <div className="purchase-stat-card mb-3">
            <div className="stat-label">Completed Purchase Orders</div>
            {poloader ? (
              <Skeleton variant="rounded" width={100} height={24} />
            ) : (
              <div className="stat-value">
                <CountUp
                  start={0}
                  end={data.confirm === undefined ? 0 : data.confirm}
                  duration={1.5}
                />
              </div>
            )}
            <div className="stat-icon-badge green">
              <TaskAltIcon fontSize="small" />
            </div>
          </div>
        </Link>
      </Col>
      <Col sm={6} lg={3}>
        <Link to={{ pathname: "/purchaseorder" }} style={{ textDecoration: "none" }}>
          <div className="purchase-stat-card mb-3">
            <div className="stat-label">Active Purchase Orders</div>
            {poloader ? (
              <Skeleton variant="rounded" width={100} height={24} />
            ) : (
              <div className="stat-value">
                <CountUp
                  start={0}
                  end={data.pending === undefined ? 0 : data.pending}
                  duration={1.5}
                />
              </div>
            )}
            <div className="stat-icon-badge red">
              <AccessTimeIcon fontSize="small" />
            </div>
          </div>
        </Link>
      </Col>
    </Row>
  );
};

export default PurchaseCards;
